ux-iws-nb-all-in-one {
    display: block;
    padding: 30px;

    @media (min-width: 1440px) {
        ux-iws-nb-all-in-one-tile {
            width: var(--tile-width);
        }
    }
}

.ux-iws-nb-all-in-one {
    &__box {
        display: block;
        box-shadow:
            0 0 15px rgba(0, 0, 0, 0.1),
            0 2px 15px -2px rgba(0, 0, 0, 0.1);

        @media (min-width: 1440px) {
            display: flex;
            flex-flow: row wrap;
            align-items: stretch;
            justify-content: flex-start;
        }
    }
}
